export default "__VITE_ASSET__69e5e66b__"